module.exports = __webpack_public_path__ + "img/18_65.279130aa.png";